/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     状态管理 getter
  +--------------------------------------------------------------------------------------
*/

import { array2Object } from '@/utils/common'

/**
 * arr2Obj: 数组转对象，value为键，title为值
 */
function arr2Obj(arr) {
  return arr.reduce((acc, cur) => {
    acc[cur.value] = cur.title
    return acc
  }, {})
}

const getters = {
  permissions: state => state.permissionStore.permissions,
  dynamicRoutes: state => state.permissionStore.dynamicRoutes,
  currentFrame: state => state.permissionStore.currentFrame,
  currentMenus: state => state.permissionStore.currentMenus,
  accessToken: state => state.userStore.accessToken,

  orderTypeObj: state => arr2Obj(state.expenseStore.orderTypeArr),
  orderStatusObj: state => arr2Obj(state.expenseStore.orderStatusArr),
  payTypeObj: state => arr2Obj(state.expenseStore.payTypeArr),
  paymentTypeObj: state => arr2Obj(state.expenseStore.paymentTypeArr),
  payStatusObj: state => arr2Obj(state.expenseStore.payStatusArr),
  shippingStatusObj: state => arr2Obj(state.expenseStore.shippingStatusArr),
  invoiceTypeObj: state => arr2Obj(state.expenseStore.invoiceTypeArr),
  orderInvoiceStatusObj: state => arr2Obj(state.expenseStore.orderInvoiceStatusArr),
  billTypeObj: state => arr2Obj(state.expenseStore.billTypeArr),
  abnormalTypeObj: state => arr2Obj(state.expenseStore.abnormalTypeArr),
  reasonCodeObj: state => arr2Obj(state.expenseStore.reasonCodeArr),

  deliveryTimeTypeObj(state) {
    return array2Object(state.eiStore.deliveryTimeTypeArr, 'id')
  },

  equipStaticObj(state) {
    return array2Object(state.rmsStore.equipStaticArr, 'equipid')
  },
  equipEventTypeObj(state) {
    return array2Object(state.rmsStore.equipEventTypeArr, 'title')
  },
  authObj(state) {
    return array2Object(state.rmsStore.authArr, 'value')
  },
  equipAuthObj(state) {
    return array2Object(state.rmsStore.equipAuthArr, 'value')
  },
  devsObj(state) {
    return array2Object(state.devStore.devsArr, 'devid')
  },
  mappingsObj(state) {
    return array2Object(state.devStore.mappingsArr, 'mappingid')
  },
  functionCodeObj(state) {
    return array2Object(state.devStore.functionCodeArr, 'value')
  },
  sensorAccessObj(state) {
    return array2Object(state.devStore.sensorAccessArr, 'value')
  },
  sensorTypeObj(state) {
    return array2Object(state.devStore.sensorTypeArr, 'value')
  },
  demicalObj(state) {
    return array2Object(state.devStore.demicalArr, 'value')
  },
  dataFormatObj(state) {
    return array2Object(state.devStore.dataFormatArr, 'value')
  },
  byteOrderObj(state) {
    return array2Object(state.devStore.byteOrderArr, 'value')
  },
  triggerEventObj(state) {
    return array2Object(state.devStore.triggerEventArr, 'value')
  },
  triggerTypeObj(state) {
    return array2Object(state.devStore.triggerTypeArr, 'value')
  }
}
export default getters
